// Gamixter Design System — Warm & Bold palette (tokens/colors.css, --gx-*).
// Key names are legacy (orange = accent, blue = contrast CTA, warmBg = app background)
// and kept to avoid churn in the ~70 files importing them.
export const brand = {
  orange: "#EA580C",
  orangeGradient: "linear-gradient(150deg, #9A3412, #C2410C 42%, #EA580C 74%, #F97316)",
  gradientTile: "linear-gradient(150deg, #C2410C, #EA580C 70%, #F97316)",
  gradientAvatar: "linear-gradient(140deg, #C2410C, #F97316)",
  tint50: "#FFF7ED",
  tint100: "#FFEDD5",
  warmBg: "#FFFBF7",
  dark: "#1C1309",
  textSecondary: "#78503A",
  textTertiary: "#A98A72",
  blue: "#1D4ED8",
  blueTint: "#EAF0FE",
  shadowWhite: "0 8px 24px rgba(28,19,9,0.06)",
  shadowLg: "0 18px 44px rgba(28,19,9,0.14)",
  shadowOrange: "0 12px 32px rgba(234,88,12,0.25)",
  shadowBlue: "0 12px 32px rgba(29,78,216,0.3)",
  accentHover: "#C2410C",
  border: "#EFE3D5",
  borderStrong: "#E2D0BC",
  surface: "#ffffff",
  surface2: "#FFF7ED",
  surface3: "#FFEDD5",
  success: "#3F8A54",
  successTint: "#EAF4EC",
  warning: "#B45309",
  warningTint: "#FBEEDD",
  danger: "#B4341C",
  dangerTint: "#FBEBE7",
  ring: "rgba(234,88,12,0.16)",
  overlay: "rgba(28,19,9,0.45)",
};

export type BrandTokens = typeof brand;

// Legacy scales remapped to the Warm & Bold palette: gray → warm brown-gray,
// blue → CTA blue, red → danger, green → success. Lightness steps preserved
// so ~190 legacy usages across game editors recolor without churn.
export const colors = {
  white: "#ffffff",
  black: "#000000",
  basicGray: "#FFF7ED",
  gray: {
    50: "#FFF7ED",
    100: "#EFE3D5",
    200: "#E2D0BC",
    300: "#A98A72",
    400: "#96755C",
    500: "#78503A",
    600: "#6B4732",
    700: "#593B28",
    800: "#44301F",
    900: "#2E2013",
    950: "#1C1309",
  },
  blue: {
    50: "#EAF0FE",
    100: "#D7E2FC",
    200: "#B7CBF9",
    300: "#8FADF4",
    400: "#5B84EA",
    500: "#1D4ED8",
    600: "#1E40AF",
    700: "#1A3894",
    800: "#172F7A",
    900: "#142861",
    950: "#0D1A40",
  },
  red: {
    50: "#FBEBE7",
    100: "#F6D7CF",
    200: "#EDB3A5",
    300: "#DE8069",
    400: "#CE5A3F",
    500: "#B4341C",
    600: "#9C2D18",
    700: "#832614",
    800: "#6B1F10",
    900: "#571A0E",
    950: "#331008",
  },
  green: {
    50: "#EAF4EC",
    100: "#D4E9DA",
    200: "#ADD4B8",
    300: "#7FB98F",
    400: "#F2F8F3",
    500: "#3F8A54",
    600: "#357447",
    700: "#2C5F3A",
    800: "#244D30",
    900: "#1D3E27",
    950: "#102316",
  },
  orange: {
    50: "#FFF6E8",
    100: "#FFEDD1",
    200: "#FFE3BA",
    300: "#FFDAA3",
    400: "#FFFAF3",
    500: "#FFD18C",
    600: "#FFC875",
    700: "#FFBF5E",
    800: "#FFB547",
    900: "#FFAC30",
    950: "#FFA318",
  },
};
